module.exports = __webpack_public_path__ + "img/row.94ab2d40.png";